import {
  Box,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  BoxProps,
  Icon,
  HStack,
} from '@chakra-ui/react';
import { RiEyeLine } from 'react-icons/ri';
import { LinkButton } from '../../../../../../../../components/LinkButton';
import { Pagination } from '../../../../../../../../components/Pagination';
import { useAuth } from '../../../../../../../../hooks/auth';
import { IBookingPaymentReport } from '../../../../../../../../services/Bookings/ListBookingPaymentReportsService';

export interface IBookingPaymentsReportTableItem extends IBookingPaymentReport {
  formattedAuthorizedAt: string;
  formattedBookedDate: string;
  formattedBookedEndTime: string;
  formattedBookedStartTime: string;
  formattedPrice: string;
  prettyWaveSide: string;
}

interface IBookingPaymentsReportTableProps extends BoxProps {
  paymentReports: IBookingPaymentsReportTableItem[];
  currentPage?: number;
  onPageChange?: (page: number) => void;
  totalPages?: number;
}

export const BookingPaymentsReportTable = ({
  paymentReports,
  currentPage,
  onPageChange,
  totalPages,
  ...rest
}: IBookingPaymentsReportTableProps): JSX.Element => {
  const { experienceLevelsTitleMap } = useAuth();

  return (
    <Box {...rest}>
      <Table colorScheme="blue" mt="4">
        <Thead>
          <Tr>
            <Th>Atividade</Th>
            <Th textAlign="center">Horário reservado</Th>
            <Th>Nível de experiência</Th>
            <Th>Comprador</Th>
            <Th>Item</Th>
            <Th>Valor</Th>
            <Th>Status</Th>
            <Th>Tipo</Th>
            <Th>Centro de custo</Th>
            <Th>Código</Th>
            <Th>Tipo (produto)</Th>
            <Th>Natureza</Th>
            <Th>Tipo de nota</Th>
            <Th textAlign="right" w="8" />
          </Tr>
        </Thead>

        <Tbody fontSize="sm">
          {paymentReports.map((paymentReport) => (
            <Tr
              key={
                paymentReport.itemId
                  ? paymentReport.itemId
                  : `${paymentReport.bookingId}-${paymentReport.itemName}-${paymentReport.nsu}-${paymentReport.authorizationCode}`
              }
            >
              <Td fontSize="sm">{paymentReport.activityName}</Td>

              <Td textAlign="center">
                <Text>{paymentReport.formattedBookedDate}</Text>

                <HStack justifyContent="center" spacing="1">
                  <Text>{`${paymentReport.formattedBookedStartTime} -`}</Text>
                  <Text>{paymentReport.formattedBookedEndTime}</Text>
                </HStack>
              </Td>

              <Td>
                <Text>
                  {experienceLevelsTitleMap.get(
                    paymentReport.scheduleExperience,
                  )}
                </Text>
              </Td>

              <Td>{paymentReport.customerName}</Td>

              <Td>{paymentReport.itemName}</Td>

              <Td>{paymentReport.formattedPrice}</Td>

              <Td>{paymentReport.status}</Td>

              <Td>{paymentReport.paymentType}</Td>

              <Td>{paymentReport.costCenter}</Td>

              <Td>{paymentReport.productCode}</Td>

              <Td>{paymentReport.productType}</Td>

              <Td>{paymentReport.productNature}</Td>

              <Td>{paymentReport.invoiceType}</Td>

              <Td textAlign="center">
                <LinkButton
                  to={{
                    pathname: '/bookings/details',
                    state: {
                      bookingId: paymentReport.bookingId,
                    },
                  }}
                >
                  <Icon as={RiEyeLine} fontSize="16" />
                </LinkButton>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      {!!currentPage && !!onPageChange && !!totalPages && totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          onPageChange={onPageChange}
          totalPages={totalPages}
        />
      )}
    </Box>
  );
};
